import { updateScanwareById } from '@/apiCalls/scanware';

import { getMchStockDetails } from './getMchStockDetails';

export async function updateScanware(fromQr: boolean): Promise<boolean> {
    await updateScanwareById();
    return await getMchStockDetails(fromQr);
}
